import { useSelector } from 'react-redux';
import { EVENTS } from 'shared/constants';
import { useKnowledgeParser } from 'shared/utils/rotations';
import { ResourceList } from 'src/components/core/select-content/resource-list.component';
import analyticsService from 'src/helpers/analytics.service';
import { displayPercentage } from 'shared/utils/quality-metrics.utils';
import { useQualityMetricsContext } from '../../quality-metrics-context';
import styles from './resources-tab.module.scss';

export function ResourcesTab() {
  const { qualityMetric, userMetric, selectedMetricId, lang } = useQualityMetricsContext();
  const knowledge = useSelector(state => state.knowledge);
  const admission = useSelector(state => state.admission);
  const lab = useSelector(state => state.lab);
  const { parse } = useKnowledgeParser({
    knowledge,
    admission,
    lab,
    resources: qualityMetric?.resources,
  });

  const analyticsTriggers = {
    open: resource => {
      analyticsService.track(EVENTS.QUALITY_METRICS.OPEN_RESOURCE, {
        userId: userMetric?.userId,
        metricId: selectedMetricId,
        metricName: qualityMetric?.title,
        goal: userMetric?.groupGoal,
        userCurrentNumerator: userMetric?.totalSuccess,
        userCurrentDenominator: userMetric?.totalRecords,
        userCurrentPercentage: displayPercentage({
          total: userMetric?.totalRecords,
          success: userMetric?.totalSuccess,
          invert: userMetric?.invert,
        }),
        groupCurrentNumerator: qualityMetric?.totalGroupSuccess,
        groupCurrentDenominator: qualityMetric?.totalGroupRecords,
        groupCurrentPercentage: displayPercentage({
          total: qualityMetric?.totalGroupRecords,
          success: qualityMetric?.totalGroupSuccess,
          invert: qualityMetric?.invert,
        }),
        startDate: qualityMetric?.startDate,
        importDate: userMetric?.updatedAt,
        resourceId: resource.id,
        resourceType: resource.type,
      });
    },
  };

  if (!qualityMetric?.resources?.length) {
    return <p className={styles.empty}>{lang.NO_DATA}</p>;
  }

  return (
    <div className={styles.container}>
      <ResourceList
        resources={qualityMetric.resources.map(parse)}
        backgroundColor="white"
        showNotFoundPanda={false}
        wrapperClass={styles.resourceItem}
        openInNewTab
        analyticsTriggers={analyticsTriggers}
        renderItemOptions={{
          showContentType: false,
          showTags: false,
          showLabels: false,
          showMetadata: false,
        }}
      />
    </div>
  );
}
